import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@mui/material';

export const UpgradeAndAnalyzeIcon: FunctionComponent = () => (
  <SvgIcon viewBox="0 0 10.581 10.581">
    <g transform="translate(-83.912577,-85.32941)">
      <path
        transform="matrix(0.26458333,0,0,0.26458333,83.912577,85.32941)"
        d="
          m 29.441406,0.08203125
          v 3.92382815 3.921875
          h -3.923828 -3.921875
          v 1.3085937 1.3085939
          h 3.921875 3.923828
          v 3.921875 3.923828
          H 30.75 32.056641
          v -3.923828 -3.921875
          h 3.923828 3.923828
          V 9.2363281 7.9277344
          H 35.980469 32.056641
          V 4.0058594 0.08203125
          H 30.75
          Z"
      />
      <path
        transform="translate(-16.633823,-1.5252947)"
        d="
          m 107.01811,94.245965
          h -0.34278
          l -0.11857,-0.13559
          c 0.42254,-0.559614 0.67692,-1.286869 0.67692,-2.083151
          0,-1.770061 -1.25466,-3.202382 -2.80251,-3.202382
          -1.54789,0 -2.8004,1.476695 -2.80257,3.202382
          h -1.0822
          l 1.65565,1.972216 1.79363,-1.972216
          h -1.50476
          c 0.003,-1.232634 0.86879,-2.216276 1.94025,-2.216276
          1.07141,0 1.9402,0.993502 1.9402,2.218741
          0,1.225239 -0.86879,2.218742 -1.9402,2.218742
          -0.27811,0 -0.54328,-0.06902 -0.78258,-0.189825
          l -0.6381,0.729717
          c 0.41604,0.281041 0.90112,0.446215 1.42068,0.446215 0.6963,0 1.33011,-0.290902 1.81947,-0.771631
          l 0.11641,0.133126
          v 0.389514
          l 2.15796,2.460337 0.64243,-0.734648
          z"
      />
    </g>
  </SvgIcon>
);
